"use strict";

define('app/template/list/template.list.view',['require','exports','module','rs/abstract.content.view','rs/models/person','moment','FileAPI','e3-common'],function (require, exports, module) {
  var AbstractContentView = require('rs/abstract.content.view');
  var PersonModel = require('rs/models/person');
  var moment = require('moment');
  var FileAPI = require('FileAPI');
  var E3 = require('e3-common');
  var TemplateListView = AbstractContentView.extend({
    events: {
      'click .filter-clear': 'handleFilterClearBtnClick',
      'keyup .filter-input': 'handleFilterInputKeyup',
      'click .data-row.template-item': 'handleDataRowClick',
      'click .btn-create-template': 'handleTemplateCreateBtnClick',
      'keydown .btn-save-create-template': 'handleTemplateSaveCreateBtnKeydown',
      'click .btn-save-create-template': 'handleTemplateSaveCreateBtnClick',
      'keydown .btn-cancel-create-template': 'handleTemplateCancelCreateBtnKeydown',
      'click .btn-cancel-create-template': 'handleTemplateCancelCreateBtnClick',
      'click .btn-save-template:not(.disabled)': 'handleTemplateSaveBtnClick',
      'click .btn-delete-template:not(.disabled)': 'handleTemplateDeleteBtnClick',
      'keydown .template-import': 'handleTemplateImportKeydown',
      'keydown .clear-template-import': 'handleClearTemplateImportKeydown',
      'click .clear-template-import': 'handleClearTemplateImportClick',
      'click .btn-edit-template-revision:not(.disabled)': 'handleTemplateRevisionEditBtnClick',
      'click .btn-delete-template-revision:not(.disabled)': 'handleTemplateRevisionDeleteBtnClick',
      'click .btn-publish-template-revision:not(.disabled)': 'handleTemplateRevisionPublishBtnClick',
      'click .btn-preview-template-revision:not(.disabled)': 'handleTemplateRevisionPreviewBtnClick',
      'click .btn-view-more-templates': 'handleTemplateViewAllRevisionsClick',
      'click .previous-revisions-btn:not(.muted)': 'handleTemplatePreviousRevisionsClick',
      'click .next-revisions-btn:not(.muted)': 'handleTemplateNextRevisionsClick'
    },
    templates: {
      'template.list.init': 'renderInitFragment',
      'template.detail.revision.row': 'renderDetailRevisionRows'
    },
    closeCreateForm: function closeCreateForm() {
      this.$('.form-new-template').slideUp();
    },
    openCreateForm: function openCreateForm() {
      $(document.body).scrollTop(0);
      this.$('.form-new-template').slideDown();
    },
    _resetForm: function _resetForm() {
      this.$('.content-form').find('input').val('');
      this.$('.content-form').find('textarea').val('');
      this.$('.checkbox-custom').removeClass('checked').trigger('change');
      this.$('.import-template-display').val('');
    },
    render: function render() {
      var data = this.getDelegate().getTemplateProperties();
      this.$el.html(this.renderInitFragment(data));
      this.processHiddenFileInput();
    },
    processHiddenFileInput: function processHiddenFileInput() {
      var input = this.$('.template-import'),
        delegate = this.getDelegate();
      FileAPI.event.on(input.get(0), 'change', function (ev) {
        var file = FileAPI.getFiles(ev)[0];
        delegate.selectImportFile(file);
      });
    },
    setImportTemplateDisplay: function setImportTemplateDisplay(val) {
      this.$('.import-template-display').val(val);
    },
    getContainer: function getContainer() {
      return this.$('.template-list-container');
    },
    getGridContainer: function getGridContainer() {
      return this.$('.template-list-grid-container');
    },
    getFormValues: function getFormValues() {
      if (this.getActiveForm() == '.form-new-template') {
        return {
          title: this.getTemplateTitle(),
          type: this.getTemplateType(),
          description: this.getTemplateDescription()
        };
      } else {
        return {
          title: this.getTemplateTitle(),
          description: this.getTemplateDescription()
        };
      }
    },
    getActiveForm: function getActiveForm() {
      if (this.$('.form-new-template').is(':visible')) {
        return '.form-new-template';
      } else {
        return '.form-update-template';
      }
    },
    getTemplateTitle: function getTemplateTitle() {
      return this.$(this.getActiveForm() + ' .template-title').val();
    },
    getImportJSON: function getImportJSON() {
      return this._importJSON || null;
    },
    showTemplateTitleError: function showTemplateTitleError(message) {
      this.$(this.getActiveForm() + ' .template-title-error .error-message').text(message);
      this.$(this.getActiveForm() + ' .template-title-error').slideDown();
    },
    showTemplateTitleSuccess: function showTemplateTitleSuccess() {
      this.$(this.getActiveForm() + ' .template-title-error').slideUp();
    },
    getTemplateType: function getTemplateType() {
      return this.$(this.getActiveForm() + ' .template-type').val();
    },
    showTemplateTypeError: function showTemplateTypeError(message) {
      this.$(this.getActiveForm() + ' .template-type-error .error-message').text(message);
      this.$(this.getActiveForm() + ' .template-type-error').slideDown();
    },
    showTemplateTypeSuccess: function showTemplateTypeSuccess() {
      this.$(this.getActiveForm() + ' .template-type-error').slideUp();
    },
    getTemplateDescription: function getTemplateDescription() {
      return E3.String.newLineToBr(this.$(this.getActiveForm() + ' .template-description').val());
    },
    clearFilterInput: function clearFilterInput() {
      this.$('.filter-input').val('');
      this.$('.filter-clear').css('visibility', 'hidden');
      this.getDelegate().requestFilter('');
    },
    handleFilterInputKeyup: function handleFilterInputKeyup(ev) {
      var el = $(ev.currentTarget),
        text = el.val();
      this.getDelegate().requestFilter(text);
      if (ev.keyCode == 27) {
        this.clearFilterInput();
      } else if (text.length) {
        el.parent().find('.filter-clear').css('visibility', 'visible');
      } else {
        el.parent().find('.filter-clear').css('visibility', 'hidden');
      }
    },
    handleFilterClearBtnClick: function handleFilterClearBtnClick() {
      this.clearFilterInput();
    },
    handleDataRowClick: function handleDataRowClick(ev) {
      var el = $(ev.currentTarget);
      this.getDelegate().requestSelectTemplateRevision(el.data('index'));
    },
    handleTemplatePreviousRevisionsClick: function handleTemplatePreviousRevisionsClick() {
      this.getDelegate().requestPreviousTemplateRevisions();
    },
    handleTemplateNextRevisionsClick: function handleTemplateNextRevisionsClick() {
      this.getDelegate().requestNextTemplateRevisions();
    },
    handleTemplateCreateBtnClick: function handleTemplateCreateBtnClick() {
      if (this.$('.form-new-template').is(':visible')) {
        this.closeCreateForm();
      } else {
        this.getDelegate().getTableController().clearSelectedItems();
        this.openCreateForm();
      }
    },
    handleTemplateImportKeydown: function handleTemplateImportKeydown(ev) {
      if (ev.keyCode === 13) {
        this.$('.hidden-file-upload').click();
      }
    },
    handleTemplateSaveCreateBtnKeydown: function handleTemplateSaveCreateBtnKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleTemplateSaveCreateBtnClick(ev);
      }
    },
    handleTemplateSaveCreateBtnClick: function handleTemplateSaveCreateBtnClick() {
      this.getDelegate().requestTemplateCreate();
    },
    handleClearTemplateImportKeydown: function handleClearTemplateImportKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleClearTemplateImportClick(ev);
      }
    },
    handleClearTemplateImportClick: function handleClearTemplateImportClick() {
      this.getDelegate().selectImportFile(null);
    },
    handleTemplateCancelCreateBtnKeydown: function handleTemplateCancelCreateBtnKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleTemplateCancelCreateBtnClick(ev);
      }
    },
    handleTemplateCancelCreateBtnClick: function handleTemplateCancelCreateBtnClick() {
      this.closeCreateForm();
    },
    handleTemplateSaveBtnClick: function handleTemplateSaveBtnClick() {
      this.getDelegate().requestTemplateSave();
    },
    handleTemplateDeleteBtnClick: function handleTemplateDeleteBtnClick() {
      this.getDelegate().requestTemplateDelete();
    },
    handleTemplateRevisionEditBtnClick: function handleTemplateRevisionEditBtnClick() {
      this.getDelegate().requestTemplateRevisionEdit();
    },
    handleTemplateRevisionDeleteBtnClick: function handleTemplateRevisionDeleteBtnClick() {
      this.getDelegate().requestTemplateRevisionDelete();
    },
    handleTemplateRevisionPublishBtnClick: function handleTemplateRevisionPublishBtnClick() {
      this.getDelegate().requestTemplateRevisionPublish();
    },
    handleTemplateRevisionPreviewBtnClick: function handleTemplateRevisionPreviewBtnClick() {
      this.getDelegate().requestTemplateRevisionPreview();
    },
    handleTemplateViewAllRevisionsClick: function handleTemplateViewAllRevisionsClick() {
      this.getDelegate().requestViewAllRevisions();
    }
  });
  module.exports = TemplateListView;
});

